import {
  REQUEST_TODAYS, RECEIVE_TODAYS, RECEIVE_TODAY,
} from '../actions/today';

const reducer = (state = {
  items: [],
  loading: false,
  item: {},
}, action) => {
  switch (action.type) {
    case REQUEST_TODAYS:
      return { ...state, loading: true };
    case RECEIVE_TODAYS:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_TODAY:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
